import { api } from '../index';

const prefix = '/api/search/';

export function apiSelectStateList() {
	return api.get(prefix + 'state');
}

export function apiSelectStateListBySalesGroup(sales_group_code) {
	return api.get(prefix + 'state', { params: { sales_group_code } });
}

export function apiSelectCountryList() {
	return api.get(prefix + 'country');
}
